import type { RouteObject } from "react-router";
import MarketplacePage from "./ui/pages/MarketplacePage";
import ToolDetailPage from "./ui/pages/ToolDetailPage";

export const marketplaceRoutes: RouteObject[] = [
    { path: "/tools-catalog", element: <MarketplacePage /> },
    { path: "/tools-catalog/:slug", element: <ToolDetailPage /> },
];
